module.exports = __webpack_public_path__ + "static/calender-icon-a2b68e27a13ca596fd59.png";